<template>
  <!--
  <div>
    <p>My Profile!</p>
    First Name : {{ this.$store.state.profileFirstName }}
    <br />
    Last Name : {{ this.$store.state.profileLastName }}
    <br />
    Username : {{ this.$store.state.profileUsername }}
    <br />
    Phone Number : {{ this.$store.state.profilePhoneNumber }}
    <br />
    Email : {{ this.$store.state.profileEmail }}
    <br />
    Cart : {{ this.$store.state.profileCart }}
  </div>
   -->
  <div class="profile">
    <Modal
      v-if="modalActive"
      :modalMessage="modalMessage"
      @close-modal="closeModal"
    />
    <div class="container">
      <h2>Account Settings</h2>
      <div class="profile-info">
        <div class="initials">{{ this.$store.state.profileInitials }}</div>
        <div v-if="isAdmin" class="admin-badge">
          <AdminIcon class="icon" />
          <span>admin</span>
        </div>
        <div class="input">
          <label for="firstName">First Name:</label>
          <input type="text" id="firstName" v-model="firstName" />
        </div>
        <div class="input">
          <label for="lastName">Last Name:</label>
          <input type="text" id="lastName" v-model="lastName" />
        </div>
        <div class="input">
          <label for="username">Username:</label>
          <input type="text" id="username" v-model="username" />
        </div>
        <div class="input">
          <label for="phoneNumber">Phone Number:</label>
          <input type="number" id="phoneNumber" v-model="phoneNumber" />
        </div>
        <div class="input">
          <label for="email">Email:</label>
          <input disabled type="text" id="email" v-model="email" />
        </div>
        <button @click.prevent="updateProfile">Save Changes</button>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../components/Modal";
import AdminIcon from "../assets/Icons/user-crown-light.svg";

export default {
  name: "Profile",
  components: {
    Modal,
    AdminIcon,
  },
  data() {
    return {
      modalActive: false,
      modalMessage: "Data Updated Successfully!",
      isAdmin: false,
    };
  },
  methods: {
    closeModal() {
      this.modalActive = !this.modalActive;
      this.$router.push({ name: "Dashboard" });
    },
    updateProfile() {
      this.$store.dispatch("updateUserProfile");
      this.modalActive = true;
    },
  },
  computed: {
    firstName: {
      get() {
        return this.$store.state.profileFirstName;
      },
      set(payload) {
        if (payload !== null && payload !== "" && payload.length !== 1) {
          this.$store.commit("changeFirstName", payload);
        } else {
          this.$store.commit(
            "changeFirstName",
            this.$store.state.profileFirstName
          );
        }
      },
    },
    lastName: {
      get() {
        return this.$store.state.profileLastName;
      },
      set(payload) {
        if (payload !== null && payload !== "" && payload.length !== 1) {
          this.$store.commit("changeLastName", payload);
        } else {
          this.$store.commit(
            "changeLastName",
            this.$store.state.profileLastName
          );
        }
      },
    },
    username: {
      get() {
        return this.$store.state.profileUsername;
      },
      set(payload) {
        if (payload !== null && payload !== "" && payload.length !== 1) {
          this.$store.commit("changeUsername", payload);
        } else {
          this.$store.commit(
            "changeUsername",
            this.$store.state.profileUsername
          );
        }
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.profilePhoneNumber;
      },
      set(payload) {
        if (payload !== null && payload !== "" && payload.length !== 1) {
          this.$store.commit("changePhoneNumber", payload);
        } else {
          this.$store.commit(
            "changePhoneNumber",
            this.$store.state.profilePhoneNumber
          );
        }
      },
    },
    email() {
      return this.$store.state.profileEmail;
    },
  },
};
</script>

<style lang="scss" scoped>
.profile {
  background-image: url("../assets/background/background13.png");
  background-repeat: no-repeat;
  background-size: cover;

  .container {
    max-width: 1000px;
    padding: 60px 25px;

    h2 {
      text-align: center;
      font-weight: 300;
      margin-bottom: 16px;
      font-size: 32px;
    }

    .profile-info {
      border-radius: 8px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
        0 2px 4px -1px rgba(0, 0, 0, 0.6);
      padding: 32px;
      background-color: #f1f1f1;
      display: flex;
      flex-direction: column;
      max-width: 600px;
      margin: 32px auto;

      .initials {
        position: initial;
        width: 80px;
        height: 80px;
        color: #fff;
        font-size: 32px;
        background-color: #303030;
        border-radius: 50%;
        display: flex;
        align-self: center;
        align-items: center;
        justify-content: center;
      }

      .admin-badge {
        display: flex;
        align-self: center;
        color: #fff;
        font-size: 14px;
        padding: 8px 24px;
        border-radius: 8px;
        background-color: #303030;
        margin: 16px 0;
        text-align: center;
        text-transform: capitalize;

        .icon {
          width: 14px;
          height: auto;
          margin-right: 8px;
        }
      }

      .input {
        margin: 16px 0;

        label {
          font-size: 14px;
          padding-bottom: 6px;
          display: block;
        }

        input {
          width: 100%;
          border: none;
          background-color: #f2f7f6;
          padding: 8px;
          height: 50px;

          @media (min-width: 900px) {
          }

          &:focus {
            outline: none;
          }
        }
      }

      button {
        align-self: center;
        width: 120px;

        &:hover {
          width: 132px;
        }
      }
    }
  }
}
</style>
